/* Tiroir « stock + ramassage » : tri par distance.
   - Bouton « Près de chez moi » : géolocalisation du navigateur, sur clic seulement.
     Rien n'est envoyé ; seules des coordonnées arrondies (~10 km) sont gardées
     dans sessionStorage (effacées à la fermeture de l'onglet).
   - Repli : code postal canadien -> province (la première lettre suffit) ; seule
     la région de tri (3 caractères) est gardée dans localStorage.
   Les coordonnées des emplacements sont approximatives (métachamp custom.geo). */
(function () {
    if (window.__stockPickupGeo) return;
    window.__stockPickupGeo = true;

    var PROVINCES = { A: 'NL', B: 'NS', C: 'PE', E: 'NB', G: 'QC', H: 'QC', J: 'QC', K: 'ON', L: 'ON', M: 'ON', N: 'ON', P: 'ON', R: 'MB', S: 'SK', T: 'AB', V: 'BC', X: 'NT', Y: 'YT' };
    var KEY_COORDS = 'ceramedGeoCoords';
    var KEY_FSA = 'ceramedGeoFsa';

    function store(storage, key, value) {
        try {
            if (value === null) storage.removeItem(key); else storage.setItem(key, value);
        } catch (e) {}
    }
    function load(storage, key) {
        try { return storage.getItem(key); } catch (e) { return null; }
    }

    function parseGeo(text) {
        var p = (text || '').split(',');
        if (p.length !== 2) return null;
        var lat = parseFloat(p[0]), lng = parseFloat(p[1]);
        return isNaN(lat) || isNaN(lng) ? null : { lat: lat, lng: lng };
    }

    function haversine(a, b) {
        var R = 6371, rad = Math.PI / 180;
        var dLat = (b.lat - a.lat) * rad, dLng = (b.lng - a.lng) * rad;
        var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        return 2 * R * Math.asin(Math.sqrt(h));
    }

    // Le modal injecte le CONTENU de #stockPickupSection (sans l'enveloppe) :
    // on retrouve donc le tiroir par sa barre de tri.
    var fsaTable = null, fsaRequest = null;

    // Table des régions de tri (3 caractères) -> [lat, lng], chargée seulement
    // quand un code postal est saisi (assets/canada-fsa.json, données GeoNames).
    function loadFsa(r) {
        if (fsaTable) return Promise.resolve(fsaTable);
        var bar = r.querySelector('[data-geo-bar]');
        var url = bar && bar.dataset.fsaUrl;
        if (!url) return Promise.resolve(null);
        if (!fsaRequest) {
            fsaRequest = fetch(url).then(function (res) {
                return res.ok ? res.json() : null;
            }).then(function (t) { fsaTable = t; return t; }).catch(function () { return null; });
        }
        return fsaRequest;
    }

    function fsaContext(fsa, table) {
        var prov = PROVINCES[fsa.charAt(0)];
        var c = table && table[fsa];
        var ctx = { prov: prov, postal: true };
        if (c) ctx.coords = { lat: c[0], lng: c[1] };
        return ctx;
    }

    function root() {
        var bar = document.querySelector('[data-geo-bar]');
        return bar ? bar.parentElement : null;
    }

    function status(r, text) {
        var el = r.querySelector('[data-geo-status]');
        if (el) el.textContent = text || '';
    }

    function clearGenerated(r) {
        r.querySelectorAll('[data-geo-generated]').forEach(function (n) { n.remove(); });
        r.querySelectorAll('[data-geo-dist]').forEach(function (n) { n.textContent = ''; });
    }

    function heading(r, text, primary) {
        var h = document.createElement('h5');
        h.className = '#stock-pickup-subtitle' + (primary ? ' @primary' : '');
        h.setAttribute('data-geo-generated', '');
        h.textContent = text;
        return h;
    }

    function label(r, km) {
        var bar = r.querySelector('[data-geo-bar]');
        var rounded = Math.round(km / 10) * 10;
        if (rounded < 10) return bar.dataset.lt10;
        return bar.dataset.km.replace('%s', rounded.toLocaleString(document.documentElement.lang || undefined));
    }

    function sortRows(r, container, ctx) {
        var rows = Array.prototype.slice.call(container.querySelectorAll('[data-geo-row]'));
        rows.forEach(function (row, i) {
            row.__i = i;
            var g = parseGeo(row.dataset.geo);
            row.__d = ctx.coords && g ? haversine(ctx.coords, g) : Infinity;
        });
        rows.sort(function (a, b) {
            var pa = ctx.prov && a.dataset.prov === ctx.prov ? 0 : 1;
            var pb = ctx.prov && b.dataset.prov === ctx.prov ? 0 : 1;
            if (ctx.coords) return (a.__d - b.__d) || (a.__i - b.__i);
            return (pa - pb) || (a.__i - b.__i);
        });
        return rows;
    }

    function applyStock(r, ctx) {
        var box = r.querySelector('[data-geo-stock]');
        if (!box) return;
        var bar = r.querySelector('[data-geo-bar]');
        var rows = sortRows(r, box, ctx);
        rows.forEach(function (row) {
            box.appendChild(row);
            var d = row.querySelector('[data-geo-dist]');
            if (d && ctx.coords && row.__d !== Infinity) d.textContent = ' · ' + label(r, row.__d);
        });
        var split, title = bar.dataset.labelProvince;
        if (ctx.coords) {
            split = rows.filter(function (x) { return x.__d <= 150; }).length;
            split = Math.min(split, 3);
            title = bar.dataset.labelNear;
            if (split === 0) { split = Math.min(3, rows.filter(function (x) { return x.__d !== Infinity; }).length); title = bar.dataset.labelClosest; }
        } else {
            split = rows.filter(function (x) { return ctx.prov && x.dataset.prov === ctx.prov; }).length;
        }
        if (rows.length > 0 && split > 0) {
            box.insertBefore(heading(r, title, true), rows[0]);
            if (rows.length > split) box.insertBefore(heading(r, bar.dataset.labelOthers), rows[split]);
        }
    }

    function applyTransfer(r, ctx) {
        var box = r.querySelector('[data-geo-transfer]');
        if (!box) return;
        var groups = Array.prototype.slice.call(box.querySelectorAll('[data-geo-province]'));
        groups.forEach(function (g, i) {
            g.__i = i;
            var rows = sortRows(r, g, ctx);
            rows.forEach(function (row) {
                g.appendChild(row);
                var d = row.querySelector('[data-geo-dist]');
                if (d && ctx.coords && row.__d !== Infinity) d.textContent = ' · ' + label(r, row.__d);
            });
            g.__d = rows.length ? rows[0].__d : Infinity;
        });
        groups.sort(function (a, b) {
            if (ctx.coords) return (a.__d - b.__d) || (a.__i - b.__i);
            var pa = ctx.prov && a.dataset.prov === ctx.prov ? 0 : 1;
            var pb = ctx.prov && b.dataset.prov === ctx.prov ? 0 : 1;
            return (pa - pb) || (a.__i - b.__i);
        });
        groups.forEach(function (g) { box.appendChild(g); g.open = false; });
        if (groups.length && (ctx.coords || ctx.prov)) {
            var first = groups[0];
            if (ctx.coords ? first.__d !== Infinity : first.dataset.prov === ctx.prov) first.open = true;
        }
    }

    function notice(r, ctx) {
        var bar = r.querySelector('[data-geo-bar]');
        var rows = Array.prototype.slice.call(r.querySelectorAll('[data-geo-row]'));
        var none = false, text = '';
        if (ctx.postal && ctx.prov) {
            none = !rows.some(function (row) { return row.dataset.prov === ctx.prov; });
            text = bar.dataset.msgNoneProvince;
        } else if (ctx.coords) {
            var best = Infinity;
            rows.forEach(function (row) {
                var g = parseGeo(row.dataset.geo);
                if (g) best = Math.min(best, haversine(ctx.coords, g));
            });
            if (best !== Infinity && best > 300) { none = true; text = bar.dataset.msgNoneNear; }
        } else if (ctx.prov) {
            none = !rows.some(function (row) { return row.dataset.prov === ctx.prov; });
            text = bar.dataset.msgNoneProvince;
        }
        if (!none || !text) return;
        var n = document.createElement('p');
        n.className = '#stock-pickup-notice';
        n.setAttribute('data-geo-generated', '');
        n.textContent = text;
        var body = r.querySelector('[class*="stock-pickup-body"]') || r;
        body.insertBefore(n, body.firstChild);
    }

    function apply(ctx) {
        var r = root();
        if (!r || !r.querySelector('[data-geo-bar]')) return;
        clearGenerated(r);
        notice(r, ctx);
        applyStock(r, ctx);
        applyTransfer(r, ctx);
    }

    function nearestProvince(r, coords) {
        var best = null, bestD = Infinity;
        r.querySelectorAll('[data-geo-row]').forEach(function (row) {
            var g = parseGeo(row.dataset.geo);
            if (!g) return;
            var d = haversine(coords, g);
            if (d < bestD) { bestD = d; best = row.dataset.prov; }
        });
        return best;
    }

    function useCoords(coords) {
        var r = root();
        if (!r) return;
        var rounded = { lat: Math.round(coords.lat * 10) / 10, lng: Math.round(coords.lng * 10) / 10 };
        store(window.sessionStorage, KEY_COORDS, rounded.lat + ',' + rounded.lng);
        apply({ coords: rounded, prov: nearestProvince(r, rounded) });
        status(r, '');
    }

    function useProvince(prov) {
        var r = root();
        if (!r) return;
        apply({ prov: prov });
        status(r, '');
    }

    function locate() {
        var r = root();
        if (!r) return;
        var bar = r.querySelector('[data-geo-bar]');
        if (!navigator.geolocation) { status(r, bar.dataset.msgDenied); return; }
        status(r, bar.dataset.msgLocating);
        navigator.geolocation.getCurrentPosition(function (pos) {
            useCoords({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        }, function () {
            status(r, bar.dataset.msgDenied);
        }, { timeout: 10000, maximumAge: 600000 });
    }

    function postal(value) {
        var r = root();
        if (!r) return;
        var clean = (value || '').replace(/\s+/g, '').toUpperCase();
        var fsa = clean.slice(0, 3);
        var prov = /^[A-Z]\d[A-Z]/.test(clean) ? PROVINCES[clean.charAt(0)] : null;
        if (!prov) { status(r, r.querySelector('[data-geo-bar]').dataset.msgInvalid); return; }
        store(window.localStorage, KEY_FSA, fsa);
        store(window.sessionStorage, KEY_COORDS, null);
        status(r, r.querySelector('[data-geo-bar]').dataset.msgLocating);
        loadFsa(r).then(function (table) {
            var current = root();
            if (!current) return;
            apply(fsaContext(fsa, table));
            status(current, '');
        });
    }

    function restore(r) {
        if (r.getAttribute('data-geo-ready') || !r.querySelector('[data-geo-bar]')) return;
        r.setAttribute('data-geo-ready', '1');
        var saved = parseGeo(load(window.sessionStorage, KEY_COORDS));
        var fsa = load(window.localStorage, KEY_FSA);
        if (saved) {
            apply({ coords: saved, prov: nearestProvince(r, saved) });
        } else if (fsa && PROVINCES[fsa.charAt(0)]) {
            var input = r.querySelector('input[name="postal"]');
            if (input) input.value = fsa;
            apply(fsaContext(fsa, fsaTable));
            if (!fsaTable) {
                loadFsa(r).then(function (table) {
                    if (table && root() === r) apply(fsaContext(fsa, table));
                });
            }
        }
    }

    document.addEventListener('click', function (e) {
        if (e.target.closest('[data-geo-locate]')) { e.preventDefault(); locate(); }
    });
    document.addEventListener('submit', function (e) {
        var f = e.target.closest('[data-geo-form]');
        if (!f) return;
        e.preventDefault();
        postal(f.querySelector('input[name="postal"]').value);
    });

    // Le tiroir est chargé à la demande : on ne surveille la page qu'entre le clic sur
    // le lien du tiroir et son apparition (6 s au plus), pas pendant toute la visite.
    var observer = null, stopTimer = null;
    function stopWatching() {
        if (observer) { observer.disconnect(); observer = null; }
        clearTimeout(stopTimer);
    }
    // Attribution CC BY 4.0 des données de codes postaux (assets/canada-fsa.json), une fois.
    var credited = false;
    function credit() {
        if (credited || !window.console) return;
        credited = true;
        console.info('Postal code data: GeoNames (https://www.geonames.org), CC BY 4.0 (https://creativecommons.org/licenses/by/4.0/).');
    }
    function watchDrawer() {
        if (observer) return;
        observer = new MutationObserver(function () {
            var r = root();
            if (r) { restore(r); credit(); stopWatching(); }
        });
        observer.observe(document.body, { childList: true, subtree: true });
        stopTimer = setTimeout(stopWatching, 6000);
    }
    document.addEventListener('click', function (e) {
        if (e.target.closest('modal-trigger[url*="r_stock-pickup"]')) watchDrawer();
    });
})();
